import React, { useState } from 'react'
import { Duration } from 'luxon'
import { TtIcon } from '@23/react'
import { useInterval } from '../../../../../../sharedLegacy/hooks'

const FocusStopwatch = () => {
  const [startTime] = useState(Date.now())
  const [currentTime, setCurrentTime] = useState(0)

  useInterval(() => {
    setCurrentTime(Date.now() - startTime)
  }, 1000)

  return (
    <div className="focus-widget focus-stopwatch">
      <TtIcon library="23" name="timer" />
      {/* TODO: take webinar locale into account */}
      <span>{Duration.fromMillis(currentTime).toFormat('mm:ss')}</span>
    </div>
  )
}

export { FocusStopwatch }
